// extracted by mini-css-extract-plugin
export var banner = "_ig-0";
export var closeButton = "_ig-2";
export var greenCheckmark = "_ig-3";
export var hereLink = "_ig-4";
export var titleIcon = "_ig-1";